// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1tORk","title":"ClientReferral_title__3Nz77","itemText":"ClientReferral_itemText__2o5SM"};